<template>
  <v-layout wrap justify-left align-center>
    <v-dialog v-model="dialogRelatorioConferencia" persistent scrollable max-width="600">
      <v-card>
        <v-card-title primary-title>
          <span class="display-1">Relatório de Conferência</span>
        </v-card-title>
        <v-divider></v-divider>
          <v-card-text style="height: 500px;">
            <v-form @keyup.native.esc="close" @keyup.native.enter="confirm()">
              <v-flex xs12>
                <v-autocomplete
                  :items="condominiosPessoa"
                  v-model="editedItem.condominios_ids"
                  label="Condominios"
                  multiple
                  item-text="id_texto"
                  item-value="id"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  :items="$auth.user().anosbases"
                  v-model="editedItem.anobase_id"
                  label="Ano Base"
                  item-text="id_texto"
                  item-value="id"
                ></v-autocomplete>
              </v-flex>
            </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="confirm">Confirmar</v-btn>
          <v-btn color="green darken-1" flat @click="close">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<style scoped>
</style>
<script>
  import PMoney from '../shared/PMoney'

  export default {
    name: 'PRelatorioConferencia',
    components: { PMoney },
    data () {
      return {
        // condominiosPessoa é preenchido no componente acima (Pessoa.vue)
        condominiosPessoa: [],
        dialogRelatorioConferencia: false,
        editedItem: {pessoa_id: '', anobase_id: '', condominios_ids: []}
      }
    },
    methods: {
      confirm () {
        this.$store.commit('loader/change_dialog', true)
        this.$http.post(`report/conferencia`, this.editedItem, {responseType: 'arraybuffer'}).then(res => {
          let blob = new Blob([res.data], {type: res.headers.get('content-type')})
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          const anobaseSelecionada = this.$auth.user().anosbases.find(a => a.id === this.editedItem.anobase_id)
          const anoCalendario = parseInt(anobaseSelecionada.id_texto)
          link.download = `conferencia-${this.editedItem['nome']}-${anoCalendario + 1}-${anoCalendario}.pdf`
          link.click()
          this.$store.commit('loader/change_dialog', false)
        }, () => this.$store.commit('loader/change_dialog', false)
        )
      },
      // confirm: function () {
      //   console.log('confirm')
      // },
      close: function () {
        this.dialogRelatorioConferencia = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/PRelatorioConferencia.vue